export enum REWARDS_CUSTOMER_ELIGIBILITY_TYPES {
    include = "include",
    exclude = "exclude",
}
